var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationStatus } from '../enums/enums';
var AuthIssueDateComponent = /** @class */ (function (_super) {
    __extends(AuthIssueDateComponent, _super);
    function AuthIssueDateComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.minDate = new Date(1948, 4, 14);
        _this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        _this.date = { day: '', month: '', year: '' };
        _this.data = {};
        return _this;
    }
    AuthIssueDateComponent.prototype.onKeyDown = function (e) {
        var date = new Date(parseInt(this.date.year), parseInt(this.date.month) - 1, parseInt(this.date.day));
        this.isValidDate = date.getDate() == parseInt(this.date.day) &&
            date.getMonth() + 1 == parseInt(this.date.month) &&
            date.getFullYear() == parseInt(this.date.year) &&
            date >= this.minDate && date < this.maxDate;
        if (e.srcElement.maxLength != null && e.srcElement.maxLength === e.srcElement.value.length) {
            e.preventDefault();
            var index = parseInt(e.srcElement.getAttribute('data-index'));
            if (index == this.inputs.length - 1) {
                document.querySelector('button').focus();
            }
            else {
                this.inputs[++index].focus();
            }
        }
    };
    AuthIssueDateComponent.prototype.elasticLogit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2157' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2157 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
    };
    AuthIssueDateComponent.prototype.ngOnInit = function () {
        this.elasticLogit();
        this.data = this.modalService.data;
        sessionStorage.setItem("currentWindow", "תאריך הנפקה ת.ז");
        sessionStorage.setItem("elasticCode", "2191");
        this.isShowContactLink = this.shouldContactLink('authIssueDate');
        var element = this.renderer.selectRootElement('#idDay');
        setTimeout(function () { return element.focus(); }, 0);
    };
    AuthIssueDateComponent.prototype.ngAfterViewInit = function () {
        this.inputs = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; });
    };
    AuthIssueDateComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid && this.isValidDate) {
            this.pending = true;
            this.serverError = null;
            //console.log("sent parametes", { ClientInsertedIdIssueDate: date });
            this.authUserService.sendAuthData("ValidateIdIssueDate", { year: parseInt(this.date.year), month: parseInt(this.date.month), day: parseInt(this.date.day) })
                .subscribe(function (res) {
                if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidIssueDate") {
                    _this.elasticLogit();
                    _this.serverError = "אנא בדוק את הפרטים שהזנת ונסה שנית";
                }
                else {
                    _this.modalService.close(res.Details);
                }
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    AuthIssueDateComponent.prototype.validateDate = function () {
        var date = new Date(parseInt(this.date.year), parseInt(this.date.month) - 1, parseInt(this.date.day));
        this.isValidDate = date.getDate() == parseInt(this.date.day) &&
            date.getMonth() + 1 == parseInt(this.date.month) &&
            date.getFullYear() == parseInt(this.date.year) &&
            date >= this.minDate && date < this.maxDate;
        //console.log(this.isValidDate);
    };
    return AuthIssueDateComponent;
}(AuthBaseComponent));
export { AuthIssueDateComponent };
